/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(value) {
    if (!('IpAddress' in value) || value['IpAddress'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'IpAddress': json['IpAddress'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'IpAddress': value['IpAddress'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions.js.map